export default function() {}



//////////////////
// WEBPACK FOOTER
// ./packages/layout/node_modules/d3-shape/src/noop.js
// module id = 45
// module chunks = 0